module.exports = __webpack_public_path__ + "img/cooperate_17.63ad12fb.png";